import _ from "lodash";
import Backbone from "backbone";
import BaseView from "scripts/views/baseView";
import DiagnosticsAuthenticationModel from "scripts/models/diagnosticsAuthenticationModel";
import inject from "scripts/ioc/inject";
import templateDiagnosticsScreen from "templates/diagnosticsScreen.hbs";
import templateDiagnosticsScreenGps from "templates/diagnosticsScreenGps.hbs";

const chan = Backbone.Radio.channel;

class DiagnosticsScreenView extends BaseView {
  constructor(options, geolocationService = inject("geolocationService")) {
    super(options);

    this.diagnosticsAuthenticationModel = new DiagnosticsAuthenticationModel();
    this.geolocationService = geolocationService;
  }

  get template() {
    return templateDiagnosticsScreen;
  }

  get events() {
    return {
      "click #bb-diagnositcs-screen-gps-button": "onClickGetGps",
      "click #bb-diagnostics-screen-back-button": "onClickBackButton",
    };
  }

  render() {
    const organization = this.diagnosticsAuthenticationModel.get(
      "organization",
    );

    this.$el.html(
      this.template(
        _.merge(
          {
            date: this.diagnosticsAuthenticationModel.get("timestamp"),
            organizationName: organization
              ? organization.organizationName
              : void 0,
          },
          this.diagnosticsAuthenticationModel.toJSON(),
        ),
      ),
    );

    return this;
  }

  renderGpsInfo(gpsInfo) {
    $("#gps-info-region").html(templateDiagnosticsScreenGps(gpsInfo));
  }

  sync() {
    return this.diagnosticsAuthenticationModel.fetch();
  }

  initialScrollTop() {
    return "bottom";
  }

  onClickGetGps() {
    chan("display").request("showBlockingLoader");

    this.geolocationService
      .getCurrentPosition()
      .then(location => {
        this.renderGpsInfo({
          gpsTime: parseInt(location.timeTaken, 10),
          gpsLatitude: location.position.coords.latitude,
          gpsLongitude: location.position.coords.longitude,
        });

        chan("display").request("hideBlockingLoader");
      })
      .catch(error => {
        console.error(error);

        chan("display").request("hideBlockingLoader");
      });
  }

  onClickBackButton() {
    chan("history").request("back");
  }
}

export default DiagnosticsScreenView;
